import React, { useState, useCallback } from "react";
import { Row, Col, Form, Button } from "antd";
import { useIntl } from "react-intl";

import { warn } from "../../../modules/messages";
import InputItem from "../../app/generic/inputItem";
import { useUserId } from "../../../modules/redux/session/useAuth";
import { changePassword, setLastPath, signOut } from "../../../modules/session";

function ChangePasswordForm({ form }) {
  const intl = useIntl();
  const { getFieldDecorator } = form;
  const formItemLayout = { colon: false };

  const userId = useUserId();

  const [loading, setLoading] = useState();
  const handleFormSubmit = useCallback(() => {
    setLoading(true);
    form &&
      form.validateFields((err, values) => {
        if (!err) {
          const result = changePassword(
            values.currentPassword,
            values.newPassword,
            values.confirmNewPassword,
            userId,
            setLoading,
          );
          if (result) {
            form.setFields(result);
          } else {
            warn(
              intl.formatMessage({
                id: "user.signOutByPassword",
                defaultMessage:
                  "Z důvodu změny hesla dojde k bezpečnostnímu odhlášení.",
              }),
            );
            setLastPath("/");
            signOut();
          }
        } else {
          setLoading(false);
        }
      });
  }, [form, intl, userId]);

  return (
    <Row type="flex" align="middle" justify="center">
      <Col sm={12} xl={6}>
        <Form {...formItemLayout}>
          <InputItem
            password
            label={intl.formatMessage({
              id: "user.currentPassword",
              defaultMessage: "Stávající heslo",
            })}
            fieldName="currentPassword"
            autoComplete="current-password"
            message={intl.formatMessage({
              id: "user.emptyCurrentPassword",
              defaultMessage: "Zadejte stávající heslo!",
            })}
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
          />
          <InputItem
            password
            label={intl.formatMessage({
              id: "user.newPassword",
              defaultMessage: "Nové heslo",
            })}
            fieldName="newPassword"
            autoComplete="new-password"
            message={intl.formatMessage({
              id: "user.emptyNewPassword",
              defaultMessage: "Zadejte nové heslo!",
            })}
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
          />
          <InputItem
            password
            autoComplete="new-password"
            label={intl.formatMessage({
              id: "user.confirmNewPassword",
              defaultMessage: "Potvrzení nového hesla",
            })}
            fieldName="confirmNewPassword"
            message={intl.formatMessage({
              id: "user.emptyConfirmNewPassword",
              defaultMessage: "Zadejte prosím znovu nové heslo!",
            })}
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
          />
          <Row>
            <Col span={3}>
              <Button
                type="primary"
                loading={loading}
                onClick={handleFormSubmit}
              >
                {intl.formatMessage({
                  id: "user.savePassword",
                  defaultMessage: "Uložit heslo",
                })}
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
}

export default Form.create()(ChangePasswordForm);
